import React, {Component, Fragment,} from 'react'
import {Collapse, Icon, Button, Row, Col} from 'antd'
import './index2.less';
import OrderFileComponent from "../../components/bus/order-file";
import {baseUrl,} from "../../api";
import {DELIVERY_TYPE_MIX, DELIVERY_TYPE_AIR, PLAN_DELIVERY_TYPE} from "../../utills/constants";

const {Panel} = Collapse;

export default class OrderBoxFile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orderId: "",
        }
    }

    componentDidMount() {
        let orderId = this.props.orderId;
        if (this.props.location) {
            orderId = this.props.location.state.orderId;
        }
        this.setState({
            orderId
        })
    }

    download = async () => {
        const url = baseUrl + "/api/v1/p/file/boxFileDownload?orderId=" + this.state.orderId;
        window.open(url, "_blank");
    };
    //设置值boxVehicle, boxDelivery, boxReturn, boxWeight
    getChildrenMsg = (objType, length) => {
        this.setState({[objType]: length})
    };
    genExtra = (objType) => {
        if (this.state[objType] > 0) {
            return <Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" onClick={event => {
                event.stopPropagation();
            }}/>
        } else {
            return <Icon type="edit" onClick={event => {
                event.stopPropagation();
            }}/>
        }
    };

    render() {
        const customPanelStyle = {
            background: '#fff',
        };
        const {deliveryType, boxWeightData,} = this.props;
        const {boxVehicle, boxDelivery, boxReturn, boxWeight, orderId,} = this.state;
        return (
            <Fragment>
                <Button type='primary' onClick={this.download}
                        disabled={!(boxVehicle > 0 || boxDelivery > 0 || boxReturn > 0 || boxWeight > 0)}>一键下载</Button>
                <Collapse bordered={false} defaultActiveKey={['1', '2', '3', '4', '5', '6', '7', '8', '9']}>
                    {DELIVERY_TYPE_AIR.hasOwnProperty(deliveryType) ? null :
                        <Panel header="提箱单" key="1" style={customPanelStyle} extra={this.genExtra("boxPickup")}>
                            <OrderFileComponent orderId={orderId} {...this.props} noQrcode={true}
                                                getChildrenMsg={this.getChildrenMsg} objectType={"boxPickup"}/>
                        </Panel>}
                    <Panel header="随车资料" key="2" style={customPanelStyle} extra={this.genExtra("boxVehicle")}>
                        <OrderFileComponent orderId={orderId} {...this.props} noQrcode={true}
                                            getChildrenMsg={this.getChildrenMsg} objectType={"boxVehicle"}/>
                    </Panel>
                    <Panel header="运单" key="3" style={customPanelStyle} extra={this.genExtra("boxDelivery")}>
                        <OrderFileComponent orderId={orderId} {...this.props} noQrcode={true}
                                            getChildrenMsg={this.getChildrenMsg} objectType={"boxDelivery"}/>
                    </Panel>
                    {DELIVERY_TYPE_AIR.hasOwnProperty(deliveryType) ? null :
                        <Panel header="还箱文件" key="4" style={customPanelStyle} extra={this.genExtra("boxReturn")}>
                            <OrderFileComponent orderId={orderId} {...this.props} noQrcode={true}
                                                getChildrenMsg={this.getChildrenMsg} objectType={"boxReturn"}/>
                        </Panel>}
                    {DELIVERY_TYPE_MIX.hasOwnProperty(deliveryType) ?
                        <Panel header="提重文件" key="5" style={customPanelStyle} extra={this.genExtra("boxWeight")}>
                            {PLAN_DELIVERY_TYPE.hasOwnProperty(deliveryType) ?
                                <Row className='general-part-item'>
                                    <Col span={6}>提柜码 : {boxWeightData.cabinetCode}</Col>
                                    <Col span={6}>MRN : {boxWeightData.dskNo}</Col>
                                    <Col span={6}>MRN获取时间 : {boxWeightData.dskDt}</Col>
                                    <Col span={6}>ATB获取时间 : {boxWeightData.atbDt}</Col>
                                </Row> :
                                <Row className='general-part-item'>
                                    <Col span={6}>DSK : {boxWeightData.dskNo}</Col>
                                </Row>}
                        </Panel> : null}
                    <OrderFileComponent orderId={orderId} {...this.props} noQrcode={true}
                                        getChildrenMsg={this.getChildrenMsg} objectType={"boxWeight"}/>
                    <Panel header="T1文件" key="6" style={customPanelStyle} extra={this.genExtra("boxT1")}>
                        <OrderFileComponent orderId={orderId} {...this.props} noQrcode={true}
                                            getChildrenMsg={this.getChildrenMsg} objectType={"boxT1"}/>
                    </Panel>
                    <Panel header="报关文件" key="7" style={customPanelStyle} extra={this.genExtra("declare")}>
                        <OrderFileComponent orderId={orderId} {...this.props} noQrcode={true}
                                            getChildrenMsg={this.getChildrenMsg} objectType={"declare"}/>
                    </Panel>
                    {DELIVERY_TYPE_AIR.hasOwnProperty(deliveryType) ?
                        <Panel header="提单" key="9" style={customPanelStyle} extra={this.genExtra("boxBillLading")}>
                            <OrderFileComponent orderId={orderId} {...this.props} noQrcode={true}
                                                getChildrenMsg={this.getChildrenMsg} objectType={"boxBillLading"}/>
                        </Panel> : null}
                    <Panel header="历史未归类文件" key="8" style={customPanelStyle}>
                        <OrderFileComponent orderId={orderId} {...this.props} readonly={true}
                                            objectType={"box"}/>
                    </Panel>
                </Collapse>
            </Fragment>
        )
    }
}